function ToggleSearchBar(e) {
    var children = e.children;
    var searchBar = document.querySelector('[data-id="search-bar"]');

    if (searchBar) {
        var active = false;
        if (searchBar.classList.contains("hide")) {
            searchBar.classList.remove("hide");
            active = true;
        } else {
            searchBar.classList.add("hide");
            active = false;
        }

        if (children.length > 0) {
            var image = children[0];

            if (active) {
                image.src = "/images/close-search.svg";
                image.classList.add("is-open");
            } else {
                image.src = "/images/search.svg";
                image.classList.remove("is-open");
            }
        }
    } 
}

function responsiveSearchFunction() {
    var inputField = document.getElementById("search");
    var magnifyingGlass = document.getElementById("search-magnifying-glass");
    if (inputField) {
        inputField.addEventListener("keydown", function (e) {

            if (e.target.value && e.target.value != "") {
                if (magnifyingGlass) {
                    if (magnifyingGlass.classList.contains("hide")) {
                        magnifyingGlass.classList.remove("hide");
                    }

                    if (!inputField.classList.contains("active")) {
                        inputField.classList.add("active");
                    }
                }
            } else {
                if (magnifyingGlass) {
                    if (!magnifyingGlass.classList.contains("hide")) {
                        magnifyingGlass.classList.add("hide");
                    }

                    if (inputField.classList.contains("active")) {
                        inputField.classList.remove("active");
                    }
                }
            }
        });

        inputField.addEventListener("keypress", function (e) {

            if (e.target.value && e.target.value.length > 0) {
                if (magnifyingGlass) {
                    if (magnifyingGlass.classList.contains("hide")) {
                        magnifyingGlass.classList.remove("hide");
                    }

                    if (!inputField.classList.contains("active")) {
                        inputField.classList.add("active");
                    }
                }
            } else {
                if (magnifyingGlass) {
                    if (!magnifyingGlass.classList.contains("hide")) {
                        magnifyingGlass.classList.add("hide");
                    }

                    if (inputField.classList.contains("active")) {
                        inputField.classList.remove("active");
                    }
                }
            }
        });

        inputField.addEventListener("onchange", function (e) {

            if (e.target.value && e.target.value != "") {
                if (magnifyingGlass) {
                    if (magnifyingGlass.classList.contains("hide")) {
                        magnifyingGlass.classList.remove("hide");
                    }

                    if (!inputField.classList.contains("active")) {
                        inputField.classList.add("active");
                    }
                }
            } else {
                if (magnifyingGlass) {
                    if (!magnifyingGlass.classList.contains("hide")) {
                        magnifyingGlass.classList.add("hide");
                    }

                    if (inputField.classList.contains("active")) {
                        inputField.classList.remove("active");
                    }
                }
            }
        });
    }
}

window.ToggleSearchBar = ToggleSearchBar;
window.responsiveSearchFunction = responsiveSearchFunction;